module.exports = __webpack_public_path__ + "static/media/243-canada.1ba6eb3d.svg";